import { createKeyFactory } from '@clouway/query'

export const configTemplatesKeys = createKeyFactory('config-templates')

export const configTemplatesListKey = () => configTemplatesKeys.list()
